//#region src/category.ts
const STATIQUE = "STATIQUE";
const BAR = "BAR";
const MANUTENTION = "MANUTENTION";
const FUN = "FUN";
const RELOU = "RELOU";
const COLLAGE = "COLLAGE";
const taskCategories = [
	STATIQUE,
	"BAR",
	MANUTENTION,
	"FUN",
	RELOU,
	COLLAGE
];
//#endregion
//#region src/action.ts
const CREATED = "CREATED";
const COMMENTED = "COMMENTED";
const READY_TO_REVIEW = "READY_TO_REVIEW";
const APPROVED = "APPROVED";
const REJECTED = "REJECTED";
const RESET_REVIEW = "RESET_REVIEW";
const ASSIGNMENT_STARTED = "ASSIGNMENT_STARTED";
const FORCED_UPDATE = "FORCED_UPDATE";
//#endregion
//#region src/review.ts
const REVIEWING = "REVIEWING";
const NOT_ASKING_TO_REVIEW = "NOT_ASKING_TO_REVIEW";
const WILL_NOT_REVIEW = "WILL_NOT_REVIEW";
const A_RELIRE = "À relire";
const REJETEE = "Rejetée";
const APPROUVEE = "Approuvée";
const PAS_DE_RELECTURE = "Pas de relecture";
const NE_VA_PAS_RELIRE = "Ne va pas relire";
const reviewLabels = /* @__PURE__ */ new Map([
	[REVIEWING, A_RELIRE],
	[APPROVED, APPROUVEE],
	[REJECTED, REJETEE],
	[NOT_ASKING_TO_REVIEW, PAS_DE_RELECTURE],
	[WILL_NOT_REVIEW, NE_VA_PAS_RELIRE]
]);
//#endregion
//#region src/status.ts
const DRAFT = "DRAFT";
const IN_REVIEW = "IN_REVIEW";
const VALIDATED = "VALIDATED";
const REFUSED = "REFUSED";
const READY_TO_ASSIGN = "READY_TO_ASSIGN";
const BROUILLON = "Brouillon";
const RELECTURE_EN_COURS = "Relecture en cours";
const VALIDEE = "Validée";
const REFUSEE = "Refusée";
const PRETE_POUR_AFFECTATION = "Prête pour affectation";
const statusLabels = /* @__PURE__ */ new Map([
	[DRAFT, BROUILLON],
	[IN_REVIEW, RELECTURE_EN_COURS],
	[REFUSED, REFUSEE],
	[VALIDATED, VALIDEE],
	[READY_TO_ASSIGN, PRETE_POUR_AFFECTATION]
]);
//#endregion
export { APPROUVEE, APPROVED, ASSIGNMENT_STARTED, A_RELIRE, BAR, BROUILLON, COLLAGE, COMMENTED, CREATED, DRAFT, FORCED_UPDATE, FUN, IN_REVIEW, MANUTENTION, NE_VA_PAS_RELIRE, NOT_ASKING_TO_REVIEW, PAS_DE_RELECTURE, PRETE_POUR_AFFECTATION, READY_TO_ASSIGN, READY_TO_REVIEW, REFUSED, REFUSEE, REJECTED, REJETEE, RELECTURE_EN_COURS, RELOU, RESET_REVIEW, REVIEWING, STATIQUE, VALIDATED, VALIDEE, WILL_NOT_REVIEW, reviewLabels, statusLabels, taskCategories };

//# sourceMappingURL=index.mjs.map